import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

/**
 * Hook to automatically refresh data when navigating between pages
 * This ensures fresh data is loaded when users switch pages
 */
export const useNavigationRefresh = () => {
  const location = useLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    // Invalidate all queries when navigating to a new page
    // This ensures fresh data is loaded
    queryClient.invalidateQueries();
  }, [location.pathname, queryClient]);
};

export default useNavigationRefresh;
